<template>
  <div>
   <header id="main-header" class="fixed-top">
	<div class="container pt-1 pb-1 d-flex justify-content-between align-items-center">
        
        <div>
            <ul className="mt-1">
              <li><i class="fab fa-facebook-f"></i></li>
              <li><i class="fab fa-twitter"></i></li>
              <li><i class="fab fa-google-plus-g"></i></li>
              <li><i class="fab fa-instagram"></i></li>
            </ul>
        </div>

   </div>
</header>

       
    
  </div>


</template>

<script>
export default {

}
</script>

<style scoped>
header{
  background: lightgray;
}
li{
    display: inline;
    font-display: none;
    margin-right: 1rem;
    color:blue;
} 

</style>